// Helpers for the Parlay of the Day feature

export const PARLAY_DISCLAIMER =
  "Parlays are high-variance and should be treated as entertainment-first. Never a lock or guaranteed play.";

export function americanToDecimal(odds: number): number {
  return odds > 0 ? odds / 100 + 1 : 100 / Math.abs(odds) + 1;
}

export function decimalToAmerican(dec: number): number {
  if (dec >= 2) return Math.round((dec - 1) * 100);
  return Math.round(-100 / (dec - 1));
}

/** Combine an array of American odds into a single American number. */
export function combineAmericanOdds(legs: number[]): number | null {
  if (!legs.length || legs.some((o) => !Number.isFinite(o))) return null;
  const dec = legs.reduce((acc, o) => acc * americanToDecimal(o), 1);
  return decimalToAmerican(dec);
}

export function todayBettingDate(tz = "America/New_York"): string {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: tz, year: "numeric", month: "2-digit", day: "2-digit",
  }).formatToParts(new Date());
  const get = (t: string) => parts.find((p) => p.type === t)!.value;
  return `${get("year")}-${get("month")}-${get("day")}`;
}

export function formatOdds(o?: number | null) {
  if (o == null) return "—";
  return o > 0 ? `+${o}` : `${o}`;
}
